module.exports = __webpack_public_path__ + "media/images/logo/Logo Artha Budaya_Ungu-d756c30e4a2da645f7b39408814d8ada.png";